import styled, { keyframes } from 'styled-components'

const loading = keyframes`
  from{
    background-position: -200px -200px;
  }to{
    background-position: -105% 105%;
  }
`

export const StyledSkeleton = styled.div`
  animation: ${loading} 1.5s linear infinite;
  background: linear-gradient(-90deg, #ffffff1c 0%, #ffffff2f 50%, #ffffff1c 100%);
  background-size: 500% 500%;
  border-radius: 8px;
  display: inline-block;
  height: 100%;
  position: relative;
  width: 100%;
  /* &:after {
    content: url("data:image/svg+xml,%3Csvg width='44' height='237' viewBox='0 0 44 237' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0.900116 237H35.4316C39.8499 237 43.4316 233.418 43.4316 229V8C43.4316 3.58172 39.8499 0 35.4316 0H0.431641C4.84991 0 8.43164 3.58172 8.43164 8V131H34.8624C40.455 131 44.3217 136.592 42.3469 141.824L8.38466 231.824C7.60872 233.881 6.04565 235.478 4.11504 236.326C3.30432 236.682 2.4288 236.906 1.51955 236.976C1.31467 236.992 1.10806 237 0.900116 237Z' fill='%23030202'/%3E%3C/svg%3E%0A");
    left: 237px;
    position: absolute;
  } */
`
// linear-gradient(-90deg, #F0F0F0 0%, #F8F8F8 50%, #F0F0F0 100%);
// linear-gradient(-90deg, #c1c1c1 0%, #f8f8f8 50%, #c1c1c1 100%);
